import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=ab6f9288&"
import script from "./MediaImage.vue?vue&type=script&lang=js&"
export * from "./MediaImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports